import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import _ from 'lodash';
import {FEATURE_TYPE} from '../constants';

export default class FeatureLists extends React.Component {
    static defaultProps = {
      activedFeatures:[],
      fullFeatureList:[]
    }
    constructor(props) {
        super(props);
        let features = this.props.fullFeatureList;
        let featuresObj = {};
        let active = [];
        features.map((feature)=>{
          featuresObj[feature.name] = feature;
        });
        (this.props.activedFeatures).map((feature)=>{
          featuresObj[feature.name] = undefined;
          active.push(feature);
        });
        this.state = {
          activedFeatures: this.props.activedFeatures,
          fullFeatureList: this.props.fullFeatureList,
          active:_.sortBy(active,['order']),
          deactived:_.values(_.omitBy(featuresObj, _.isNil))
        }
    }
    static getDerivedStateFromProps(props, state) {
      if ((props.fullFeatureList.length != state.fullFeatureList.length) || (props.activedFeatures.length != state.activedFeatures.length)) {
        let features = props.fullFeatureList;
        let featuresObj = {};
        let active = [];
        features.map((feature)=>{
          featuresObj[feature.name] = feature;
        });
        (props.activedFeatures).map((feature)=>{
          featuresObj[feature.name] = undefined;
          active.push(feature);
        });
        return {
          activedFeatures: props.activedFeatures,
          active:_.sortBy(active,['order']),
          deactived:_.values(_.omitBy(featuresObj, _.isNil))
        };
      }
      return null;
    }
    onDragEnd(result){
      let destination = result.destination;
      let source = result.source;
      let state = this.state;
      if (!destination) return;
      if (source.droppableId !== destination.droppableId) {
        let sourceList = state[source.droppableId];
        let destinationList = state[destination.droppableId];
        let [removed] = sourceList.splice(source.index, 1);
        destinationList.splice(destination.index, 0, removed);
        this.setState(state);
      } else {
        let sourceList = state[source.droppableId];
        let [removed] = sourceList.splice(source.index, 1);
        sourceList.splice(destination.index, 0, removed);
      }
    }
    getActiveList(){
      let active = this.state.active;
      active.map((item,key)=>{
        item.order = key;
      })
      return(active);
    }
    _hangleCheckBoxChange(index,value){
      let active = this.state.active;
      active[index].enabled = !active[index].enabled;
      this.setState({active:active});
    }
    render() {
        return (
          <div>
            <div className='d-flex align-items-stretch'>
              <div className='div-list-section pb-0 w-50 border-right'>
                <div className='div-list-desc'>
                  <div className='desc-header'>List of function</div>
                  <div className='desc-content'>Drag and drop the options to right side.</div>
                </div>
              </div>
              <div className='div-list-section pb-0 w-50'>
                <div className='div-list-desc'>
                  <div className='desc-header'>Functions available for this merchant</div>
                  <div className='desc-content'>The checkbox indicates what options are active.</div>
                </div>
              </div>
            </div>
            <div className='d-flex align-items-stretch'>
              <DragDropContext onDragEnd={this.onDragEnd.bind(this)}>
                  <div className='div-list-section pt-0 w-50 border-right' >
                    <Droppable droppableId="deactived">
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}  style={{"height":"100%"}}>
                          {this.state.deactived.map((item, index) => (
                            <Draggable
                              key={item.name}
                              className='div-feature'
                              draggableId={item.name}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{backgroundColor: snapshot.isDragging ? 'lightgreen' : '#F0F0F0',"marginBottom":5,"padding":8,...provided.draggableProps.style}}
                                >
                                  <div>
                                    <span className="checkbox pl-3 checkbox-checkbox">
                                        &nbsp;
                                        <input
                                            type="checkbox"
                                            value={item.name}
                                            checked={false}
                                            readOnly
                                            disabled
                                        />
                                        <div className="checkbox_box" style={{backgroundColor:"#4242427a","borderColor":"4242427a"}}></div>
                                        <span data-translation={'merchant.settings.features.'+item.name}>{FEATURE_TYPE[item.name]}</span>
                                    </span>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                      )}
                    </Droppable>
                  </div>
                  <div className='div-list-section pt-0 w-50'>
                    <Droppable droppableId="active">
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef} style={{"height":"100%"}}>
                          {this.state.active.map((item, index) => (
                            <Draggable
                              key={item.name}
                              className='div-feature'
                              draggableId={item.name}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{backgroundColor: snapshot.isDragging ? 'lightgreen' : '#F0F0F0',"marginBottom":5,"padding":8,...provided.draggableProps.style}}
                                >
                                  <div>
                                    <span className="checkbox pl-3 checkbox-checkbox" onClick={this._hangleCheckBoxChange.bind(this,index)}>
                                        &nbsp;
                                        <input
                                            type="checkbox"
                                            value={item.name}
                                            checked={item.enabled}
                                            readOnly
                                        />
                                        <div className="checkbox_box"></div>
                                        <span data-translation={'merchant.settings.features.'+item.name}>{FEATURE_TYPE[item.name]}</span>
                                    </span>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                    </Droppable>
                  </div>
              </DragDropContext>
            </div>
          </div>
        );
    }
}
